export default __webpack_public_path__ + "static/media/banner-3.fca69599.png";